module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wedding_websites-5b0d0fadd6ef8f9cf693759a5e748a52.svg";